
import { defineComponent } from "vue";
import { beforeWindowUnloadHander } from "../helpers/helpers";

export default defineComponent({
  name: "BreathingExercise",

  watch: {
    "$store.state.exercise.started"(val) {
      if (val) {
        window.addEventListener("beforeunload", beforeWindowUnloadHander);
      } else {
        window.removeEventListener("beforeunload", beforeWindowUnloadHander);
      }
    },
  },
});
